import { TableConfigV2 } from 'hooks/useMuiTableBuilderV2';
import { TeamIdCell } from './DataCells/TeamIdCell';
import { TeamNameCell } from './DataCells/TeamNameCell';
import { TeamMembersCell } from './DataCells/TeamMembersCell';
import { TeamLastActivityCell } from './DataCells/TeamLastActivityCell';
import { TeamCreatedAtCell } from './DataCells/TeamCreatedAtCell';
import { TeamTagsCell } from './DataCells/TeamTagsCell';
import { TeamIdHeaderCell } from './HeaderCells/TeamIdHeaderCell';
import { TeamNameHeaderCell } from './HeaderCells/TeamNameHeaderCell';
import { TeamMembersHeaderCell } from './HeaderCells/TeamMembersHeaderCell';
import { TeamLastActivityHeaderCell } from './HeaderCells/TeamLastActivityHeaderCell';
import { TeamCreatedAtHeaderCell } from './HeaderCells/TeamCreatedAtHeaderCell';
import { TeamTagsHeaderCell } from './HeaderCells/TeamTagsHeaderCell';
import { LoaderCell } from '../../../../components/Cells/LoaderCell';

export const COLUMNS = {
  TEAM_ID: 'id',
  TEAM_NAME: 'name',
  CREATED_AT: 'created_at',
  TAGS: 'tags',
  CSM: 'csm',
  LAST_ACTIVITY: 'last_user_activity_at',
  MEMBERS: 'actives_count',
};

export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
  LOADER: 'LOADER',
};

export const getTableConfig = (): TableConfigV2 => {
  const tableConfigs = {
    hasStickyHeader: true,
    tableHeaderTitle: 'Inactive Team',
    rowTypes: ROW_TYPES,
    hideToolbar: true,
    columnsMinWidth: {
      [COLUMNS.TEAM_ID]: 40,
      [COLUMNS.TEAM_NAME]: 40,
    },
    columns: [
      COLUMNS.TEAM_ID,
      COLUMNS.TEAM_NAME,
      COLUMNS.MEMBERS,
      COLUMNS.LAST_ACTIVITY,
      COLUMNS.CREATED_AT,
      COLUMNS.TAGS,
    ],
    cellsByRowTypesAndColumns: {
      [ROW_TYPES.DATA]: {
        [COLUMNS.TEAM_ID]: TeamIdCell,
        [COLUMNS.TEAM_NAME]: TeamNameCell,
        [COLUMNS.MEMBERS]: TeamMembersCell,
        [COLUMNS.LAST_ACTIVITY]: TeamLastActivityCell,
        [COLUMNS.CREATED_AT]: TeamCreatedAtCell,
        [COLUMNS.TAGS]: TeamTagsCell,
      },
      [ROW_TYPES.HEADER]: {
        [COLUMNS.TEAM_ID]: TeamIdHeaderCell,
        [COLUMNS.TEAM_NAME]: TeamNameHeaderCell,
        [COLUMNS.MEMBERS]: TeamMembersHeaderCell,
        [COLUMNS.LAST_ACTIVITY]: TeamLastActivityHeaderCell,
        [COLUMNS.CREATED_AT]: TeamCreatedAtHeaderCell,
        [COLUMNS.TAGS]: TeamTagsHeaderCell,
      },
      [ROW_TYPES.LOADER]: {
        [COLUMNS.TEAM_ID]: TeamIdCell,
        [COLUMNS.TEAM_NAME]: LoaderCell,
        [COLUMNS.MEMBERS]: LoaderCell,
        [COLUMNS.LAST_ACTIVITY]: LoaderCell,
        [COLUMNS.CREATED_AT]: LoaderCell,
        [COLUMNS.TAGS]: LoaderCell,
      },
    },
  };

  return tableConfigs;
};
